export default class DateFormat {
    static dateToPlain(date) {
        if (!(date instanceof Date)) {
            throw new Error('date given is not instance of Date class!');
        }

        let month = `${date.getMonth() + 1}`;
        let day = `${date.getDate()}`;
        const year = date.getFullYear();
        if (month.length < 2) month = `0${month}`;
        if (day.length < 2) day = `0${day}`;

        return year + month + day;
    }

    static plainToDashed(date) {
        let clonedDate = date;
        if (clonedDate === null || typeof clonedDate === 'undefined') return '';
        clonedDate = clonedDate.toString();
        if (clonedDate.length < 8) return '';
        return [clonedDate.substring(0, 4), clonedDate.substring(4, 6), clonedDate.substring(6, 8)].join('-');
    }

    static dashedToPlain(date) {
        let clonedDate = date;
        if (clonedDate === null || typeof clonedDate === 'undefined') return '';
        clonedDate = clonedDate.toString();
        if (clonedDate.length < 8) return '';
        return clonedDate.split('-').join('').split(' ')[0];
    }

    static plainToDotted(date) {
        let clonedDate = date;
        if (clonedDate === null || typeof clonedDate === 'undefined') return '';
        clonedDate = clonedDate.toString();
        clonedDate = clonedDate.replace(/\D/g, '');
        if (clonedDate.length < 8) return '';
        return [clonedDate.substring(0, 4), clonedDate.substring(4, 6), clonedDate.substring(6, 8)].join('.');
    }

    static plainToSlashed(date) {
        let clonedDate = date;
        if (clonedDate === null || typeof clonedDate === 'undefined') return '';
        clonedDate = clonedDate.toString();
        if (clonedDate.length < 8) return '';
        return [clonedDate.substring(0, 4), clonedDate.substring(4, 6), clonedDate.substring(6, 8)].join('/');
    }

    static intToDate(date) {
        const clonedDate = date;
        return new Date(
            parseInt(clonedDate.toString().substring(0, 4), 10),
            parseInt(clonedDate.toString().substring(4, 6), 10) - 1,
            parseInt(clonedDate.toString().substring(6, 8), 10),
        );
    }

    static msToDays(ms) {
        return Math.floor(ms / (1000 * 60 * 60 * 24));
    }
}
